module.exports = "pegasus/assets/themelp1/product/110.png";